import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { AuthService } from '../../auth.service';
import { environment } from '../../../environments/environment';
import { UserProfileService } from '../../api/user-profile.service';

import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'iv-deeplinking-page',
  templateUrl: './deeplinking-page.component.html',
  styleUrls: ['./deeplinking-page.component.scss']
})
export class DeepLinkingPageComponent implements OnInit {

  opportunityNumber = null;
  opportunityName = null;
  deepLinkingCountry = null;
  deepLinkingLocale = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.deepLinkingIntegration();
  }

  sanitizeURL(url: string): SafeUrl { 
    return this.sanitizer.sanitize(SecurityContext.URL, url);
  }

  deepLinkingIntegration() {
    if (this.activatedRoute.snapshot.queryParams.opportunity_number && 
      this.activatedRoute.snapshot.queryParams.opportunity_name &&
      this.activatedRoute.snapshot.queryParams.country) {
        this.opportunityNumber = this.activatedRoute.snapshot.queryParams.opportunity_number;
        this.opportunityName = this.activatedRoute.snapshot.queryParams.opportunity_name;
        this.deepLinkingCountry = this.activatedRoute.snapshot.queryParams.country;
        this.deepLinkingLocale = this.authService.getLocaleFromUrl(window.location.pathname);

        // Setting parameters to be checked later on in the Invoice Status Component
        this.authService.setPreviousURL(`${this.sanitizeURL(window.location.pathname + window.location.search)}`);
        this.userProfileService.setDeeplinkingCountryLocalStorage(this.deepLinkingCountry);

        const selectedCountry = this.userProfileService.getCountryObjectByURL(this.deepLinkingLocale, this.deepLinkingCountry);
        
        if (this.deepLinkingCountry !== this.userProfileService.getCountryLocalStorage() || this.deepLinkingLocale !== this.userProfileService.getLocale()) {
          if (selectedCountry.country_not_found) {
            // ERROR: User has not access to the selected country. Verify user's profile.
            window.location.href = `${this.sanitizeURL(`${environment.finishlineurl}${this.userProfileService.getLocale()}/unauthorized${window.location.search}`)}`;
          } else {
            this.userProfileService.saveUserSelectedCountry({ country: selectedCountry.value, lang: selectedCountry.lang })
            .pipe(
              untilDestroyed(this)
            )
            .subscribe((response: any) => {
              if (response && response.result === 'Successfully Updated the Country and Language') {
                /* 
                * INFO: After the redirection, the getEmployeeId() will be called in the top section of the APP,
                * updating the localStorage with the user's information, we just need to update the locale and port at this time.
                */ 
                this.userProfileService.setLocale(this.deepLinkingLocale);
                this.authService.setPort(selectedCountry.port);
                window.location.href = `${this.sanitizeURL(`${environment.finishlineurl}${this.deepLinkingLocale}/landing${window.location.search}`)}`;
              }
            });
          }
        } else {
          this.router.navigateByUrl(`/landing${window.location.search}`);
        }
    } else {
      // Redirects to Landing Page
      this.router.navigateByUrl('/landing');
    }
  }

}
